/** @format */

import { useContext, useEffect, useState } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { checkLogin } from '../../Shared/hooks/authenticate';
import { canSelfRegisterOnEvent } from '../../Shared/utils/helper';
import { useRole } from '../../Shared/hooks/CustomHooks';
import Master from '../Layouts/Master';

const SelectGender = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { can, canBoard } = useRole();
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(true);
  const [eventGender, setEventGender] = useState(3);

  useEffect(() => {
    if (!checkLogin()) {
      error('برای ادامه ابتدا وارد حساب کاربری خود شوید');
      const back = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?back=${back}`, { replace: true });
      return;
    }

    useApi.get(
      `/event/${id}`,
      {},
      (res) => {
        const data = res.data.data;
        if (!canSelfRegisterOnEvent(data, { can, canBoard })) {
          error(
            'ثبت‌نام این رویداد فقط توسط ادمین یا هیئت استان انجام می‌شود',
          );
          navigate('/', { replace: true });
          return;
        }
        eventContext.event = data;
        setEventGender(Number(data.gender) || 3);
        setLoading(false);
      },
      () => {
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
        setLoading(false);
      },
    );
  }, [id, eventContext.authRoles, location.pathname, location.search, navigate]);

  if (loading) {
    return <Loading />;
  }

  const showMale = eventGender === 1 || eventGender === 3;
  const showFemale = eventGender === 2 || eventGender === 3;

  return (
    <Master
      showSidebar={false}
      containerFullWidth={true}
      headerFixed={true}
      title={`انتخاب جنسیت`}
    >
      <div className='image-cover'>
        <div className='home-back-img w-100 d-flex flex-column'>
          <div className='row mx-2 my-4'>
            <div className='col-12'>
              <div className='w-100 p-2 f-14 rounded-2 font-weight-bold text-white bg-purple my-3 justify-content-start align-items-start text-left'>
                جنسیت خود را انتخاب کنید :
              </div>
            </div>
            {showMale ? (
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 overflow-hidden mx-0 px-0'>
                <div className='d-flex flex-column justify-content-center align-items-center'>
                  <Link
                    to={`/event/register/${id}?gender=1`}
                    className='bg-purple rounded-circle text-center d-flex flex-column text-white f-30 font-family font-weight-bold justify-content-center align-content-center'
                    style={{ width: '250px', height: '250px' }}
                  >
                    مرد
                  </Link>
                </div>
              </div>
            ) : null}
            {showFemale ? (
              <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 overflow-hidden mx-0 px-0'>
                <div className='d-flex flex-column justify-content-center align-items-center'>
                  <Link
                    to={`/event/register/${id}?gender=2`}
                    className='bg-purple rounded-circle text-center d-flex flex-column text-white f-30 font-family font-weight-bold justify-content-center align-content-center'
                    style={{ width: '250px', height: '250px' }}
                  >
                    زن
                  </Link>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </Master>
  );
};

export default SelectGender;
